<template>
  <div class="whychoose">
    <!-- <van-image
                class="whychoose-img"
                width="205"
                height="50"
                fit="cover"
                :src="require('@/assets/pc-box-3-title.png')" /> -->
    <div class="why">
      <h2>为何选择<span>儿童手机管理</span></h2>
    </div>
    <div class="why-img">
      <img src="../../assets/pc-box-3-icon.png" alt="">
    </div>
    <!-- <van-grid>
                  <van-grid-item>
                    <img slot="icon" src="@/assets/pc-box-3-icon-1.png" />
                    <p slot="text">实时位置</p>
                  </van-grid-item>
                  <van-grid-item>
                    <img slot="icon" src="@/assets/pc-box-3-icon-2.png" />
                    <p slot="text">安全围栏</p>
                  </van-grid-item>
                  <van-grid-item>
                    <img slot="icon" src="@/assets/pc-box-3-icon-3.png" />
                    <p slot="text">应用限制</p>
                  </van-grid-item>
                  <van-grid-item>
                    <img slot="icon" src="@/assets/pc-box-3-icon-4.png" />
                    <p slot="text">手机时长限制</p>
                  </van-grid-item>
                  <van-grid-item>
                    <img slot="icon" src="@/assets/pc-box-3-icon-5.png" />
                    <p slot="text">使用详情</p>
                  </van-grid-item>
                  <van-grid-item>
                    <img slot="icon" src="@/assets/pc-box-3-icon-6.png" />
                    <p slot="text">远程截屏</p>
                  </van-grid-item>
                  <van-grid-item>
                    <img slot="icon" src="@/assets/pc-box-3-icon-7.png" />
                    <p slot="text">学习模式</p>
                  </van-grid-item>
                  <van-grid-item>
                    <img slot="icon" src="@/assets/pc-box-3-icon-1.png" />
                    <p slot="text">社交管理</p>
                  </van-grid-item>
                </van-grid> -->
  </div>
</template>

<script>
export default {
  name: 'whychoose'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.whychoose {
  height: 350px;
  padding: 35px 0;
  background-color: #F7FDFD;
}

/* .van-image:nth-child(1) {
  display: block;
  margin: 0 auto;
}
img{
  width: 30px;
  height: 30px;
  margin-bottom: 5px;
}
p{
  font-size: 14px;
}
.whychoose /deep/.van-grid-item__content{
  padding: 40px 0 0;
  background-color: #F7FDFD;
} */
.why {
  height: 50px;
  font-size: 15px;
  text-align: center;
  margin-bottom: 10px;
}

.why span {
  color: #5098ff;
}

.why-img {
  width: 100%;
  height: 300px;
}

.why-img img {
  width: 100%;
  height: 100%;
}
</style>
